var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-upload',{attrs:{"action":'#',"http-request":_vm.onFileUpload,"accept":_vm.fileTypes==null?'':_vm.fileTypes.join(','),"show-file-list":false,"disabled":_vm.disabled,"before-upload":_vm.beforeUpload,"multiple":true}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }